import React from 'react'
import SbEditable from 'storyblok-react'
import cx from 'classnames'

import Carousel from './../Carousel'
import ButtonPrimary from './../ButtonPrimary'

import styles from './styles.module.scss'

const ProductCarousel = (props) => {

    const params = {
        slidesPerView: typeof window != 'undefined' && window.innerWidth < 900 ? 1 : 2,
        loop: true,
        grabCursor: true,
        speed: 750,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false
        }
    }

	return (
		<SbEditable content={props.blok}>
			<section className={styles['product-carousel']}>
                {props.blok.vertical_title && <span className={'section-title'}>{props.blok.title}</span>}
                <Carousel params={params}>
                    {props.blok.products.map(blok => {

                        const innerClasses = cx({
                            [styles['product-item__inner']]: true,
                            [styles['product-item__inner--no-image']]: !blok.image.filename
                        })

                        const imageClasses = cx({
                            [styles['product-item__image-wrapper']]: true,
                            [styles['product-item__image-wrapper--left']]: blok.image_alignment == 'left',
                            [styles['product-item__image-wrapper--right']]: blok.image_alignment == 'right'
                        })

                        return (
                            <article key={blok._uid} className={styles['product-item']}>
                                <SbEditable content={blok}>
                                    <div className={innerClasses} style={{ backgroundColor: blok.background_color }}>
                                        <div className={styles['product-item__content']}>
                                            <h4 className={`heading-4 ${styles['product-item__heading']}`}><b>{blok.heading}</b></h4>
                                            <p className={`body ${styles['product-item__description']}`}>{blok.description}</p>
                                            {blok.button.map((button) => {
                                                return (
                                                    <SbEditable content={button} key={button._uid}>
                                                        <ButtonPrimary label={button.label} link={button.link} />
                                                    </SbEditable>
                                                )
                                            })}
                                        </div>
                                        {blok.image.filename && (
                                            <figure className={imageClasses}>
                                                <img className={styles['product-item__image']} src={blok.image.filename} alt={blok.image.alt} />
                                            </figure>
                                        )}
                                    </div>
                                </SbEditable>
                            </article>
                        )
                    })}
                </Carousel>
            </section>
		</SbEditable>
	)
}

export default ProductCarousel
